import React from "react";
import "./ActionButton.css";

interface ActionButtonProps {
  icon?: React.ReactNode;
  text: string;
  onClick: () => void;
  responsive?: boolean;
  secondary?: boolean;
  disabled?: boolean;
}

const ActionButton: React.FC<ActionButtonProps> = ({
  icon,
  text,
  onClick,
  responsive = false,
  secondary = false,
  disabled = false,
}) => {
  return (
    <button
      className={`action-button ${responsive ? "responsive" : ""} ${
        secondary ? "secondary" : ""
      }`}
      disabled={disabled}
      onClick={onClick}
    >
      {icon}
      <span>{text}</span>
    </button>
  );
};

export default ActionButton;
